require('./myProfileDocumentationInsurancesView.scss')

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const Immutable = require('immutable');
const { sortByOrder } = require('lodash');

// @ components
const InsurancesProfileDocumentation = require('./insurancesProfileDocumentation/insurancesProfileDocumentation');

class MyProfileDocumentationInsurancesView extends React.Component {

    constructor(props) {
        super(props);
    }

    buildDocumentList() {

        const { immInsurances, callbackDownloadFileInsurances, documentDownloadingPolicyNumber, documentsFetch } = this.props;
        const insurancesIsEmpty = !immInsurances.get('insurances').size;
        let insurancesDocuments;
        if (!insurancesIsEmpty) {
            const immDocuments = immInsurances.get('insurances');
            
            insurancesDocuments = !immDocuments ? [] : immDocuments.map((immDocument) => {
                const generationDate = function () {
                    let genDate = immDocument.get('effectiveDate');
                    return genDate.split('-').join("");
                }
                const documentDesc = immDocument.get('documentList').map(doc => {
                    return {
                        documentType: doc.get('name'),
                        idDocument: immDocument.get('policyNumber'),
                        policyVersion: immDocument.get('policyVersion'),
                    }
                })
                return {
                    generationDate: generationDate(),
                    insuranceTypeName: immDocument.get('productDesc'),
                    documentDesc,
                    policyCode: immDocument.get('policyNumber'),
                }
            });
            insurancesDocuments = sortByOrder(insurancesDocuments.toJS(), ['generationDate'], ['asc']);
            return (
                <InsurancesProfileDocumentation
                    data={Immutable.fromJS(insurancesDocuments)}
                    callbackDownloadFile={callbackDownloadFileInsurances}
                    documentDownloadingPolicyNumber={documentDownloadingPolicyNumber}
                    documentsFetch={documentsFetch}
                />
            );
        }

    }

    render() {
        const documentList = this.buildDocumentList();
        return (
            <section className="insurances-profile-documentation-view">
                {documentList}
            </section>
        );
    }
}

MyProfileDocumentationInsurancesView.propTypes = {
    immInsurances: PropTypes.object.isRequired,
    callbackDownloadFileInsurances: PropTypes.func,
    documentDownloadingPolicyNumber: PropTypes.string,
    documentsFetch: PropTypes.object,
};

module.exports.constructor = MyProfileDocumentationInsurancesView;

module.exports = MyProfileDocumentationInsurancesView;
